import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Modal,
  Label,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function SellersList() {
  const history = useHistory()
  const [modal_small, setModalSmall] = useState(false)
  const [formData, setFormData] = useState({ status: "", userId: "" })

  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const toggleModal = () => setModalSmall(!modal_small)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const [customers, setCustomers] = useState([])
  const [filteredCustomers, setFilteredCustomers] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    getCustomers()
  }, [])

  const getCustomers = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetCustomers,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setCustomers(res.data.customers)
        setFilteredCustomers(res.data.customers)
      })
      .catch(error => {
        console.error("Error fetching customers:", error)
      })
  }

  const handleSearch = e => {
    const value = e.target.value
    setSearchTerm(value)

    if (value.trim() === "") {
      setFilteredCustomers(customers)
      setPageNumber(0)
      return
    }

    const token = TokenData
    axios
      .post(
        URLS.GetCustomers + e.target.value,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setFilteredCustomers(res.data.customers || [])
        setPageNumber(0)
      })
      .catch(error => {
        console.error("Search error:", error)
        toast.error("Search failed")
        setFilteredCustomers([])
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const displayCustomers = filteredCustomers.slice(
    pagesVisited,
    pagesVisited + listPerPage
  )
  const pageCount = Math.ceil(filteredCustomers.length / listPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const viewCustomer = customer => {
    sessionStorage.setItem("Custid", customer.userId)
    history.push("/ViewCustomer")
  }

  const openEditPopup = item => {
    setFormData(item)
    setModalSmall(true)
  }

  const handleSubmit = e => {
    e.preventDefault()
    updateSupportTicket()
  }

  const updateSupportTicket = async () => {
    const dataToSend = {
      payment_type: formData.payment_type,
      userId: formData.userId,
    }
    const token = TokenData
    try {
      const response = await axios.post(
        `${URLS.UpdateCustomerpayments}`,
        dataToSend,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      toast.success(response.data.message)
      getCustomers()
      setModalSmall(false)
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update support ticket"
      )
      console.error("Error updating support ticket:", error)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Customer List"
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={3}>
                      <div className="float-right mb-3">
                        <Input
                          type="search"
                          name="search"
                          value={searchTerm}
                          onChange={handleSearch}
                          className="form-control"
                          placeholder="Search by name or phone..."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    <Table hover className="table-bordered">
                      <thead>
                        <tr>
                          <th>SlNo</th>
                          <th>Profile</th>
                          <th>Customer Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Payment Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayCustomers.length > 0 ? (
                          displayCustomers.map((customer, index) => (
                            <tr key={customer._id}>
                              <td>{pagesVisited + index + 1}</td>
                              <td>
                                <div className="avatar-sm me-3">
                                  <div className="avatar-title rounded-circle bg-white">
                                    {customer.profilePic ? (
                                      <img
                                        src={URLS.Base + customer.profilePic}
                                        alt="User Avatar"
                                        className="avatar-sm rounded-circle"
                                      />
                                    ) : (
                                      <div className="avatar-sm rounded-circle d-flex align-items-center justify-content-center bg-light">
                                        <i className="bx bx-user text-muted"></i>{" "}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>{customer.name || "-"}</td>
                              <td>{customer.mobile || "-"}</td>
                              <td>{customer.email || "-"}</td>
                              <td>{customer.payment_type || "-"}</td>
                              <td>
                                <i
                                  className="mdi mdi-eye-circle-outline text-primary me-2"
                                  onClick={() => viewCustomer(customer)}
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                                <i
                                  className="bx bx-edit text-primary me-2 "
                                  onClick={() => openEditPopup(customer)}
                                  style={{
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No customers found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pageCount > 1 && (
                      <div className="d-flex justify-content-end mt-3">
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
          <Modal size="md" isOpen={modal_small} toggle={toggleModal} centered>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Payment Update</h5>
              <button
                onClick={() => setModalSmall(false)}
                type="button"
                className="close"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={handleSubmit}>
                <Col md={12}>
                  <div className="mb-3">
                    <Label>
                      Payment Status <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="select"
                      className="form-select"
                      required
                      value={formData.payment_type || ""}
                      name="payment_type"
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="postpay">Post-Pay</option>
                      <option value="prepay">Pre-Pay </option>
                    </Input>
                  </div>
                </Col>
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    onClick={() => setModalSmall(false)}
                    color="danger"
                    type="button"
                    className="me-2"
                    size="sm"
                  >
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" size="sm">
                    Submit
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SellersList
